import { Component, Input, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-jaccontent',
  templateUrl: './help-jaccontent.component.html'
})
export class HelpJACContentComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private route: Router) {
   
  }
  jacc_heading;
  jacc_desc;
  jacc_para1heading;
  jacc_para1body;
  jacc_para2heading;
  jacc_para2body;
  jacc_para3heading;
  jacc_para3body;
  jacc_para4heading;
  jacc_para4body;
  // IsRightPanel:boolean;
  @Input() IsRightPanel:boolean=false;
  ngOnInit(): void {
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();
    
    this.commonDataService.showLoader.next(true);
    window.scrollTo(0, 0);
    this.gethelpjaccontentlabels();
  }
  gethelpjaccontentlabels() {

    this.graphQlService.gethelpJACContentLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.jacc_heading = labels.filter(x => x.key == "jacc_heading").map(y => y.value);
        this.jacc_desc = labels.filter(x => x.key == "jacc_desc").map(y => y.value);
        this.jacc_para1heading = labels.filter(x => x.key == "jacc_para1heading").map(y => y.value);
        this.jacc_para1body = labels.filter(x => x.key == "jacc_para1body").map(y => y.value);
        this.jacc_para2heading = labels.filter(x => x.key == "jacc_para2heading").map(y => y.value);
        this.jacc_para2body = labels.filter(x => x.key == "jacc_para2body").map(y => y.value);
        this.jacc_para3heading = labels.filter(x => x.key == "jacc_para3heading").map(y => y.value);
        this.jacc_para3body = labels.filter(x => x.key == "jacc_para3body").map(y => y.value);
        this.jacc_para4heading = labels.filter(x => x.key == "jacc_para4heading").map(y => y.value);
        this.jacc_para4body = labels.filter(x => x.key == "jacc_para4body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
}
